<template>
    <div class="data_select">
            <div class="data_select_box" v-for="item in options" :key="item.option_id">
                <div class="data_select_ensure" :style="'width:' + (item.answer_cnt/done_cnt*100) + '%;'">
                    <!-- <span style="margin-left:15px">{{setNumberToLetter(index + 1)}}</span> -->
                    <span style="margin-left:15px">已填写</span>
                </div>
                <div class="data_select_text">
                    {{item.answer_cnt}}人 {{isNaN((item.answer_cnt/done_cnt*100).toFixed(1)) ? 0:(item.answer_cnt/done_cnt*100).toFixed(1)}}%
                </div>
            </div>
            <div class="problem">
                <div class="problem_title">{{index + 1}}. {{title}}</div>
                <van-image
                  width="100%"
                  height="100%"
                  v-if="img_url !== ''"
                  :src="img_url"
                />
                <!-- <div class="proble_select" v-for="(item, index) in options" :key="item.option_id">{{setNumberToLetter(index + 1)}}. {{item.title}}</div> -->
            </div>
    </div>
</template>

<script>
import numberToLetter from '../../../../utils/NumberToLetter'
export default {
  props: {
    title: {
      type: String
    },
    options: {
      type: Array
    },
    question_id: {
      type: Number
    },
    done_cnt: {
      type: Number
    },
    index: {
      type: Number
    },
    img_url: {
      type: String
    }
  },
  methods: {
    setNumberToLetter (num) {
      return numberToLetter(num)
    }
  }
}
</script>

<style lang='scss' scoped>
.data_select{
        background: #fff;
        width: 91.47%;
        margin: 10px auto;
        padding: 5px 0;
        border-radius: 12px;
        .data_select_box{
            margin: 10px auto;
            width: 91.47%;
            height: 30px;
            line-height: 30px;
            display: flex;
            justify-content: space-between;
            background-color: #e7edf5;
            border-radius: 6px;
            position: relative;
            .data_select_ensure{
                width: 100%;
                background-color: #19cca0;
                border-radius: 6px;
            }
            .data_select_text{
                position: absolute;
                margin-left: 60%;
                width: 40%;
                text-align: end;
            }
        }
        .problem{
            width: 91.47%;
            margin: 10px auto;
            .problem_title{
                font-weight: 500;
                margin-bottom: 5px;
            }
            .proble_select{
                margin: 2px 0;
                font-size: 14px;
            }
        }
    }
</style>
